// The players' rank (backend/ranking.py, CLAUDE.md « Rank »): rank points (PR) won or lost in
// every game, six ranks, the first five in three divisions (III → II → I). The same numbers as the
// server: keep them equal.

export const TIERS = [
  { id: "bronze", floor: 0 },
  { id: "argent", floor: 600 },
  { id: "or", floor: 1200 },
  { id: "platine", floor: 1800 },
  { id: "diamant", floor: 2400 },
  { id: "maitre", floor: 3000 },
];
export const DIVISION_SPAN = 200;
export const CALIBRATION_GAMES = 5;

const ROMAN = { 1: "I", 2: "II", 3: "III" };

/**
 * Everything a screen shows of a rank ({rp, games}, or null when unknown): the rank and its
 * division, the points of the next step and how far along the player is. A player who has not
 * played CALIBRATION_GAMES games yet is `calibrating` (no rank shown).
 */
export function rankInfo(rank) {
  const rp = Math.max(0, Math.round(rank?.rp ?? 0));
  const games = rank?.games ?? 0;
  let index = 0;
  TIERS.forEach((tier, i) => { if (rp >= tier.floor) index = i; });
  const tier = TIERS[index];
  const top = index === TIERS.length - 1;
  const step = top ? 0 : Math.min(2, Math.floor((rp - tier.floor) / DIVISION_SPAN));
  const division = top ? null : 3 - step;
  const from = top ? tier.floor : tier.floor + step * DIVISION_SPAN;
  const next = top ? null : step === 2 ? TIERS[index + 1].floor : from + DIVISION_SPAN;
  return {
    rp,
    games,
    calibrating: games < CALIBRATION_GAMES,
    tier: tier.id,
    tierIndex: index,
    division,
    roman: division ? ROMAN[division] : "",
    from,
    next,
    progress: next == null ? 1 : (rp - from) / (next - from),
  };
}

// "Or II", "Maître": the rank's name in the player's language (tierName: t("rank.tiers.<id>")).
export const rankLabel = (info, tierName) => (info.roman ? `${tierName} ${info.roman}` : tierName);

// Whether a change went up to a new rank or division (the end screen's promotion).
export function promotion(before, after) {
  const a = rankInfo(before);
  const b = rankInfo(after);
  if (b.tierIndex > a.tierIndex) return "tier";
  if (b.tierIndex === a.tierIndex && (b.division ?? 0) < (a.division ?? 0)) return "division";
  return null;
}
